export interface IcaLoginDto {
    // SN
    key: string,
    // 随机数 8位
    data: string,
    // 签名结果
    sign: string,
    // 签名证书
    secret: string
    grant_type: string,
    scope: string
}

export const downloadLink = [
    // {
    //     link: "https://casign.hnsggzy.com:7080/ca-hunanplatform/operation/downLoad?fileType=unify",
    //     title: "湖南CA驱动下载"
    // },
    {
        link: "https://casign.hnsggzy.com:7080/ca-hunanplatform/operation/downLoad?fileType=unify",
        title: "湖南省公共资源CA共享平台驱动下载"
    },
    {
        link: "https://ebsoss.hbncp.com.cn/website/湖北一毂数据服务有限公司/20230317/湖北CA驱动与签章控件.zip",
        title: "湖北CA驱动下载"
    }
    
    

]

class State {
    public messageVisible: boolean = false;
    public loginMessage: string = "";

    public loading: boolean = false;
    btnLoading: boolean = false;

    public title: any = "";
    
    public currentTab: number = 1;

    public currentLoginWay: number = 1

    // ca状态 0-未初始化 1-初始化成功 2-初始化失败
    public CAState: number = 0

    /**是否勾选协议 */
    checkAgreement: boolean = false;

    /**协议文件*/
    fileCode: string = '';

    /**ca方式*/
    caWay: number = 0
}

// tslint:disable-next-line:no-empty-interface
export interface IState extends State { }

export const initState: IState = new State();
